/**
 * Sanitize and validates the numeric value of a field against its maskº
 * @param {CampoSolicitud} campo
 * @param {'string'|'number'} valor
 * @returns {Number}
 */
export const numericValidation = (campo, valor, blurValidation = false) => {
  const value = valor.replace(/[^0-9,.]/g, '').replace(',', '.')

  if (isNaN(value)) {
    /** Returns all but last character */
    return value.slice(0, -1)
  }

  return value
}
